<div class="main-wrapper" nxRow>
    <form [formGroup]="mainForm" style="width: 100%; display: flex; justify-content: center;">
    <div style="width:100%;">
        <qbe-progress-stepper style="cursor: pointer;"
            [stepperConfig]="{
                totalSteps: totalSteps,
                currentStepIndex: sharedService.stepIndex,
                currentProgress: sharedService.progress,
                stepsLabels: stepsLabels 
                }"
              
            [renderAllSteps]="renderAllSteps"
            
            [progressStepperTitle]="progressStepperTitle"
            [hideLeftArrowIcon]="hideLeftArrowIcon"
            (goBackClick)="goBackClick()"
            (stepClick)="stepClick($event)"
        >
    	</qbe-progress-stepper>

        <ng-container  *ngIf="errorBanner">
            <div nxLayout="grid" class="error-baner"  style="width:100%;">
              <nx-message-banner  context="error" closable="true" (close)="closeBanner()">
                {{ 'error.choosenOneOfTheOptions' | translate}}
              </nx-message-banner>
            </div>
          </ng-container>
          
        <ng-container *ngFor="let step of sharedService.steps; let i = index">
            <div [label]="step.title | translate" [stepControl]="mainForm">
                <div class="nx-margin-top-s">
                    <div>
                        <ng-container *ngFor="let r of sharedService.range">
                            <router-outlet (activate)="onActivate($event)" *ngIf="i === sharedService.stepIndex && r === sharedService.progress"></router-outlet>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
        
        <!-- <nx-progress-stepper #stepper [progress]="sharedService.progress" [selectedIndex]="sharedService.stepIndex"
                             class="stepper" currentStepLabel="Step" >
            <ng-container *ngFor="let step of sharedService.steps; let i = index">
                <nx-step [label]="step.title | translate" [stepControl]="mainForm">
                    <div class="nx-margin-top-s">
                        <div>
                            <ng-container *ngFor="let r of sharedService.range">
                                <router-outlet (activate)="onActivate($event)" *ngIf="i === sharedService.stepIndex && r === sharedService.progress"></router-outlet>
                            </ng-container>
                        </div>
                    </div>
                </nx-step>
            </ng-container>
        </nx-progress-stepper> -->
    </form>
</div>
<app-footer *ngIf="!sharedService.loadingStep && !sharedService.loadingSpinner" class="app-footer-wrapper"></app-footer>

<!-- <app-footer class="app-footer-wrapper"></app-footer> -->
